import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import PricingTable from "@/components/site/PricingTable";
import StickyDemoCta from "@/components/site/StickyDemoCta";
import JsonLd from "@/components/site/JsonLd";
import { buildFaqSchema } from "@/lib/schema";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const pricingFaq = [
    { q: "How long is the free trial?", a: "The Starter plan is free for 60 days — no credit card required. After that, you'll need to upgrade to Pro or Business to continue using PipeGuide. Your data remains accessible during this period." },
    { q: "Can I cancel anytime?", a: "Yes. All plans are month-to-month. Email support@pipeguide.tech with a written cancellation request and your plan stays active for 30 days, then downgrades to the free Starter tier. No penalties, no fees, no commitment periods." },
    { q: "Why is billing in ZAR?", a: "Our payment processor (Paystack) settles transactions in South African Rand. International customers see prices in USD for transparency, and your card issuer handles the conversion automatically at the standard market rate. There is no FX surcharge on our side." },
    { q: "Do you offer discounts for non-profits or startups?", a: "Yes — early-stage startups (under R10m ARR) and registered non-profits can apply for a 30% discount on Pro and Business plans. Email us at support@pipeguide.tech." },
    { q: "Can I add more seats mid-month?", a: "Absolutely. Extra rep, admin and manager seats can be added at any time and are pro-rated for the remainder of your billing month." },
    { q: "Is training included?", a: "Optional Training & Setup is available on Pro (R30,000 / $1,667) and Business (R55,000 / $3,056). It includes custom framework design, CRM mapping, and a half-day live workshop with your team." },
    { q: "What if I run out of calls before the month ends?", a: "Grab a one-time Call Pack (25 or 50 calls) or a Power Caller top-up for a single rep. Packs drop into your plan instantly — no auto-renew, no surprise bills." },
];

export default function Pricing() {
    return (
        <div data-testid="pricing-page" className="min-h-screen flex flex-col bg-white">
            <JsonLd id="faq-pricing" data={buildFaqSchema(pricingFaq)} />
            <div className="bg-white border-b border-zinc-200">
                <Navbar tone="light" />
            </div>

            <section className="bg-gradient-to-b from-zinc-50 to-white">
                <div className="max-w-7xl mx-auto px-6 sm:px-8 py-20 md:py-28">
                    <div className="text-center max-w-2xl mx-auto">
                        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-primary">Pricing</p>
                        <h1 className="mt-3 font-display text-5xl sm:text-6xl font-bold tracking-tight text-zinc-900">
                            Honest pricing.
                        </h1>
                        <p className="mt-5 text-lg text-zinc-600">
                            Start free for one rep. Upgrade when your team is ready. Every plan includes the live AI qualification engine — only seats and limits change.
                        </p>
                    </div>

                    <div className="mt-14">
                        <PricingTable />
                    </div>
                </div>
            </section>

            <section className="bg-zinc-50 border-y border-zinc-200">
                <div className="max-w-4xl mx-auto px-6 sm:px-8 py-20">
                    <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900 text-center">
                        Pricing questions
                    </h2>
                    <Accordion type="single" collapsible className="mt-10 space-y-3">
                        {pricingFaq.map((f, i) => (
                            <AccordionItem key={i} value={`pf-${i}`} data-testid={`pricing-faq-${i}`} className="rounded-xl border border-zinc-200 bg-white px-5 data-[state=open]:border-brand-accent-muted">
                                <AccordionTrigger className="font-display text-base sm:text-lg font-semibold text-left text-zinc-900 hover:no-underline py-5">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-zinc-600 leading-relaxed pb-5">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </section>

            <Footer />
            <StickyDemoCta />
        </div>
    );
}
